<template>
  <MapRoute
    :coordinates="computedCoordinates"
    :map="map"
    :routeMapper="routeMapper"
    line-color="#3e8dba"
    :line-width="4"
  />
</template>

<script>
export default {
  name: 'AnimatedMapRoute',
  props: {
    duration: {
      type: Number,
      default: 3000
    },
    coordinates: {
      type: Array
    },
    map: {
      type: Object
    },
    draw: {
      type: Number
    }
  },
  created() {
    this.drawRoute()
  },
  data() {
    return {
      animationIndex: ref(0)
    }
  },
  computed: {
    computedCoordinates() {
      return this.coordinates.slice(0, this.animationIndex)
    }
  },
  watch: {
    draw() {
      this.drawRoute()
    }
  },

  methods: {
    routeMapper(route) {
      const coordinates = route.map(({ latitude, longitude }) => [longitude, latitude])
      return coordinates
    },
    drawRoute() {
      this.animationIndex = 0
      const startTime = Date.now()
      const animate = () => {
        const now = Date.now()
        const progress = (now - startTime) / this.duration
        this.animationIndex = Math.floor(progress * this.coordinates.length)
        if (this.animationIndex < this.coordinates.length) {
          requestAnimationFrame(animate)
        } else {
          this.$emit('onComplete')
        }
      }
      animate()
    },
    restartAnimation() {
      this.animationIndex = 0
      this.drawRoute()
    }
  }
}
</script>
